import { ReactElement } from 'react';
import { SearchPage } from './search/SearchPage';
import { PaymentDetailPage } from './paymentDetails/PaymentDetailPage';
import { ArtifactDetailPage } from './artifactDetails/ArtifactDetailPage';
import { ExecutionDetailPage } from './executionDetails/ExecutionDetailPage';
import { BulkSearchResults } from './bulkSearch/BulkSearchResults';
import { paymentSearchDescriptor } from './bulkSearch/paymentSearchDescriptor';
import { artifactSearchDescriptor } from './bulkSearch/artifactSearchDescriptor';
import { executionSearchDescriptor } from './bulkSearch/executionSearchDescriptor';

export interface Page {
  path: string;
  title: string;
  content: ReactElement;
  matchExactPath: boolean;
  description?: string;
}

export const searchPage: Page = {
  path: '/',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const searchAltPage: Page = {
  path: '/search',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const paymentDetailPage: Page = {
  path: '/payment',
  title: 'Payment Detail',
  content: <PaymentDetailPage />,
  matchExactPath: true,
  description: 'Payment lifecycle detail view',
};

export const artifactDetailPage: Page = {
  path: '/artifact',
  title: 'Artifact Detail',
  content: <ArtifactDetailPage />,
  matchExactPath: true,
  description: 'Artifact lifecycle detail view',
};

export const executionDetailPage: Page = {
  path: '/execution',
  title: 'Execution Detail',
  content: <ExecutionDetailPage />,
  matchExactPath: true,
  description: 'Execution lifecycle detail view',
};

export const bulkPaymentsPage: Page = {
  path: '/payments',
  title: 'Bulk Payments',
  content: <BulkSearchResults descriptor={paymentSearchDescriptor} />,
  matchExactPath: true,
  description: 'Bulk payment search results',
};

export const bulkArtifactsPage: Page = {
  path: '/artifacts',
  title: 'Bulk Artifacts',
  content: <BulkSearchResults descriptor={artifactSearchDescriptor} />,
  matchExactPath: true,
  description: 'Bulk artifact search results',
};

export const bulkExecutionsPage: Page = {
  path: '/executions',
  title: 'Bulk Executions',
  content: <BulkSearchResults descriptor={executionSearchDescriptor} />,
  matchExactPath: true,
  description: 'Bulk execution search results',
};

/**
 * All pages in route order.
 */
export const allPages: Page[] = [
  searchPage,
  searchAltPage,
  paymentDetailPage,
  artifactDetailPage,
  executionDetailPage,
  bulkPaymentsPage,
  bulkArtifactsPage,
  bulkExecutionsPage,
];
